import React from 'react';
import PropTypes from 'prop-types';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import StarBorderIcon from '@material-ui/icons/StarBorder';

const StarRating = ({ value, size }) => {
  const stars = [];
  const full = Math.floor(value);
  const hasHalf = value - full >= 0.5;
  for (let i = 0; i < 5; i += 1) {
    if (i < full) stars.push(<StarIcon key={i} style={{ fontSize: size, color: '#F5A623' }} />);
    else if (i === full && hasHalf) stars.push(<StarHalfIcon key={i} style={{ fontSize: size, color: '#F5A623' }} />);
    else stars.push(<StarBorderIcon key={i} style={{ fontSize: size, color: '#D0D5DD' }} />);
  }
  return <span style={{ display: 'inline-flex', alignItems: 'center' }}>{stars}</span>;
};

StarRating.propTypes = {
  value: PropTypes.number.isRequired,
  size: PropTypes.number,
};

StarRating.defaultProps = {
  size: 18,
};

export default StarRating;
